import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { CommonService } from '@shared/services/common.service';

@Component({
    selector: 'sso-login',
    templateUrl: './sso-login.component.html',
    styleUrl: './sso-login.component.scss',
    standalone: false
})
export class SsoLoginComponent implements OnInit {

  constructor(
    private router: Router, 
    private route: ActivatedRoute, 
    private authService: AuthService, 
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    const authCode = this.route.snapshot.queryParams['code'];
    if (authCode) {
      this.handleAuthCode(authCode);
    } else {
      this.initiateLogin()
    }
  }

  handleAuthCode(authCode: string) {  
    this.authService.exchangeAuthCodeForTokens(authCode).subscribe(
      (tokens) => {
        let postLoginUrl = sessionStorage.getItem('post_login_url');
        sessionStorage.removeItem('post_login_url');

        if (postLoginUrl) {
          postLoginUrl = decodeURIComponent(postLoginUrl);
        }

        this.authService.implicitAuthentication(tokens.access_token, tokens.refresh_token, tokens.id_token);

        this.commonService.provisionSsoUser().subscribe(
          (_) => {
            this.authService.resetUserInactivityMonitor();
            
            if (postLoginUrl && postLoginUrl.startsWith('/dl?')) {
              let qpObject = {};
              let qp = postLoginUrl.replace('/dl?', '').split('&');
              qp.forEach((p) => {
                var key = p.substring(0, p.indexOf('='));
                var value = p.substring(p.indexOf('=') + 1, p.length);
                qpObject[key] = value;
              });
              this.router.navigate(['/login'], { queryParams: qpObject });
            } else if (postLoginUrl && postLoginUrl.startsWith('/rev-doc-view-dispatch')) {
              let qpObject = {};
              let qp = postLoginUrl.replace('/rev-doc-view-dispatch?', '').split('&');
              qp.forEach((p) => {
                var key = p.substring(0, p.indexOf('='));
                var value = p.substring(p.indexOf('=') + 1, p.length);
                qpObject[key] = value;
              });
              this.router.navigate(['/rev-doc-view-dispatch'], { queryParams: qpObject });
            } else {
              this.router.navigate(['/login']);
            }
          },
          (error) => {
            console.error('Failed to provision sso user', error);
            this.router.navigate(['/login']);
          }
        )
      },
      (error) => {
        console.error('SSO login failed:', error);
        this.router.navigate(['/login']);
      }
    );
  }

  async initiateLogin() {
    const postLoginUrl = this.route.snapshot.queryParams['post_login_url'];
    sessionStorage.setItem('post_login_url', postLoginUrl);

    const identityProvider = this.route.snapshot.params['identity_provider'];
    const authUrl = await this.authService.prepareOAuthLogin(identityProvider);
    window.location.href = authUrl;
  }

}
